import GigEndConfirmModal from './GigEndConfirmModal'
import { connect } from 'react-redux'
import { State } from '../../dataStore/reducers/reducerType'
import { closeGigEndConfirmationModal } from '../../dataStore/actions/ui/uiActions'
import { GigEndConfirmModalProps } from './types'
import { setToLiveEnded } from '../../dataStore/actions/gig/gigActions'

const mapStateToProps = (state: State) => ({
  isLive: state.ui.isLive,
  isOpen: state.ui.showGigEndConfirmationModal
})

const mapDispatchToProps = (dispatch): Pick<GigEndConfirmModalProps, 'onCancel' | 'onConfirm'> => ({
  onCancel: () => dispatch(closeGigEndConfirmationModal()),
  onConfirm: () => dispatch(setToLiveEnded())
})

export default connect(mapStateToProps, mapDispatchToProps)(GigEndConfirmModal)
